module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.setUpFileUploader
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "profile-photo-picker"
  }, [_c('div', {
    attrs: {
      "id": "croppie"
    }
  }), _vm._v(" "), (!_vm.image) ? _c('div', {
    on: {
      "click": _vm.addPhoto
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("Upload Photo")])]) : _vm._e(), _vm._v(" "), (_vm.image) ? _c('p', {
    on: {
      "click": _vm.addPhoto
    }
  }, [_vm._v("Change Photo")]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-circle"
  }, [_c('img'), _vm._v(" "), _c('span', {}, [_vm._v("800 x 800")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46c81dbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/ProfileImage.vue
// module id = 707
// module chunks = 1